import { jsx as _jsx } from "react/jsx-runtime";
import { MenuItemWrapper } from './BKJMenuItem.styled.js';
export const BKJMenuItem = ({ onClick, disabled, width, borderRadius, children, justifyContent, padding, role, tabIndex, onKeyDown, ...rest }) => {
    const computedRole = role ?? 'menuitem';
    const computedTabIndex = tabIndex ?? (disabled ? -1 : 0);
    const handleKeyDown = (event) => {
        onKeyDown?.(event);
        if (event.defaultPrevented)
            return;
        if (disabled)
            return;
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            onClick?.(event);
        }
    };
    const handleClick = (event) => {
        if (disabled)
            return;
        onClick?.(event);
    };
    return (_jsx(MenuItemWrapper, { role: computedRole, tabIndex: computedTabIndex, "aria-disabled": disabled ? true : undefined, borderRadius: borderRadius, width: width, disabled: disabled, onClick: handleClick, onKeyDown: handleKeyDown, justifyContent: justifyContent, padding: padding, ...rest, children: children }));
};
//# sourceMappingURL=BKJMenuItem.js.map